import { authClient, API } from "../index";

// Pagar la cuenta de la mesa (QR de mesa con el programa de caja del restaurante)

export const getMesa = (codigo) => authClient().get(`${API}/cobro-cuenta/mesa/${codigo}`);

export const crearCobroMesa = (codigo, body) =>
  authClient().post(`${API}/cobro-cuenta/mesa/${codigo}`, body);

export const revalidarCobro = (cobroId) =>
  authClient().post(`${API}/cobro-cuenta/${cobroId}/revalidar`);

export const getCobro = (cobroId) => authClient().get(`${API}/cobro-cuenta/${cobroId}`);
